import axios from "axios";
import moment from "moment";
import React, { useEffect } from "react";
import { alertRef } from "../../../App";
import DatePicker from "../../../Components/DatePicker/DatePicker";
import Dropdown from "../../../Components/Dropdown/Dropdown";
import Modal from "../../../Components/Modal/Modal";
import { Button, Input } from "../../../Components/StyledComponents";
import { convertBuisnessNum } from "../../../Utils/functions";
import './JungsanInfo.scss';
import SetAddress from "./SetAddress/SetAddress";

const JungsanInfo = () => {
    const [ isModify, setIsModify ] = React.useState(false);//정산 정보 수정여부
    const [ taxation, setTaxation ] = React.useState('간이과세자')//과세구분
    const [ businessNum, setBusinessNum ] = React.useState('');//사업자 등록번호
    const [ businessCondition, setBusinessCondition ] = React.useState('');// 업태
    const [ businessSectors, setBusinessSectors ] = React.useState('');//업종
    const [ storeName, setStoreName ] = React.useState('');//상호명
    const [ openDate, setOpenDate ] = React.useState(new Date());//개엽연월일
    const [ name, setName ] = React.useState('');//대표자명
    const [ birth, setBirth ] = React.useState(new Date());//생년월일
    const [ accountHolder, setAccountHolder ] = React.useState('');//예금주명
    const [ bank, setBank ] = React.useState('');//은행
    const [ bankCode, setBankCode ] = React.useState('')//은행 코드
    const [ accountNum, setAccountNum ] = React.useState('');//계좌번호
    const [ address, setAddress ] = React.useState('');//사업장 소재지
    const [ roadAddress, setRoadAddress ] = React.useState('');//사업장 소재지 도로명 주소
    const [ detailAddress, setDetailAddress ] = React.useState('');//사업장 소재지 상세주소
    const [ bankList, setBankList ] = React.useState([])//은행 목록

    const modalRef = React.useRef(null)

    useEffect(() => {
        getInfo()
    },[])

    //정산 정보 Get
    const getInfo = () => {
        axios.get('/api/jungsan/info')
        .then((data) => {
            getBankList()
            if(typeof data.data.JungsanInfo !== 'undefined'){
                setStoreName(data.data.JungsanInfo.StoreName);
                setBusinessNum(data.data.JungsanInfo.BusinessNum);
                setName(data.data.JungsanInfo.Name);
                setBusinessCondition(data.data.JungsanInfo.BusinessCondition);
                setBusinessSectors(data.data.JungsanInfo.BusinessSectors);
                setTaxation(data.data.JungsanInfo.Taxation);
                setAccountHolder(data.data.JungsanInfo.AccountHolder);
                setAccountNum(data.data.JungsanInfo.AccountNumber);
                setOpenDate(new Date(data.data.JungsanInfo.OpeningDate));
                setAddress(data.data.JungsanInfo.Address);
                setRoadAddress(data.data.JungsanInfo.RoadAddress);
                setDetailAddress(data.data.JungsanInfo.DetailAddress);
                setBirth(new Date(data.data.JungsanInfo.BirthYear.toString() + '-' + data.data.JungsanInfo.BirthMonth.toString().padStart(2,'0') + '-' + data.data.JungsanInfo.BirthDay.toString().padStart(2,'0')))
                setBank(data.data.JungsanInfo.Bank.Name)
                setBankCode(data.data.JungsanInfo.Bank.Code)
            }
        })
        .catch(() => {
            getBankList()
        })
    }

    //주소 검색 후 상태 저장 handler
    const handleAddress = (data) => {
        let jibunAddress = '';
        let roadAddress = '';
        
        if (data.jibunAddress !== '') {
            jibunAddress = data.jibunAddress
        }else {
            jibunAddress = data.autoJibunAddress
        }

        if (data.roadAddress !== '') {
            roadAddress = data.roadAddress
        }else {
            roadAddress = data.autoRoadAddress
        }

        setAddress(jibunAddress)
        setRoadAddress(roadAddress);
        modalRef.current.closeModal()
    }

    //은행 목록 및 코드 Get
    const getBankList = () => {
        let list = []
        axios.get('/api/bank')
        .then( (data) => {
            if(data){
                for( let i = 0; i < data.data.length;i++){
                    list.push({ key : data.data[i].Name, value : { Name : data.data[i].Name, Code : data.data[i].Code } })
                }
                setBankList(list)
            }
        })
    }

    //check validation
    const isDisabled = () => {
        if(storeName.trim() === '' ||
        businessNum.trim().length < 12 ||
        name.trim() === '' ||
        birth === '' ||
        openDate === '' ||
        roadAddress === '' ||
        address === '' ||
        detailAddress.trim() === '' ||
        businessCondition.trim() === '' ||
        businessSectors.trim() === '' ||
        taxation === '' ||
        accountHolder.trim() === '' ||
        accountNum.trim() === '' ||
        bank === '') return true
        else return false
    }

    //수정 상태일경우 validation check 후 상태 저장 아닐경우 수정 상태로 변환
    const toggleModify = () => {
        if( !isModify ){
            setIsModify(old => !old)
        }else {
            if(
                storeName.trim() === '' ||
                businessNum.trim().length < 12 ||
                name.trim() === '' ||
                birth === '' ||
                openDate === '' ||
                roadAddress === '' ||
                address === '' ||
                detailAddress.trim() === '' ||
                businessCondition.trim() === '' ||
                businessSectors.trim() === '' ||
                taxation === '' ||
                accountHolder.trim() === '' ||
                accountNum.trim() === '' ||
                bank === ''
            ){
                alertRef.current.showAlert({ title : `입력 정보를 확인해주세요.`, isCancel : true, cancelText : '확인', onConfirm : () => alertRef.current.hideAlert() })
                return;
            }
            axios.patch('/api/jungsan/info',{
                    StoreName : storeName,
                    BusinessNum : businessNum,
                    Name : name,
                    BirthYear : Number(moment(birth).utc().format('YYYY')),
                    BirthMonth : Number(moment(birth).utc().format('MM')),
                    BirthDay : Number(moment(birth).utc().format('DD')),
                    OpeningDate : moment(openDate).utc().format('YYYY-MM-DD'),
                    Address : address,
                    RoadAddress : roadAddress,
                    DetailAddress : detailAddress,
                    BusinessCondition : businessCondition,
                    BusinessSectors : businessSectors,
                    Taxation : taxation,
                    AccountHolder : accountHolder,
                    AccountNumber : accountNum,
                    Bank : { Name : bank, Code : bankCode },
            })
            .then((data) => {
                if(data.status === 204 ){
                    setIsModify(false);
                    getInfo();
                    alertRef.current.showAlert({ title : `정산 정보가 저장되었어요.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
                }
            })
            .catch(() => {
                alertRef.current.showAlert({ title : `입력 항목을 확인해 주세요.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
            })
        }
    }

    return (
        <div className="jungsan-info">
            <div className="info-box">
                <div className="header-row">
                    <p className="info-box-title">사업자 등록정보</p>
                    <Button variant={isModify ? 'sub' : 'outline'} small style={{ paddingLeft : 16, paddingRight : 16 }} onClick={() => toggleModify()} disabled={isModify && isDisabled()}>
                        { isModify ?  '저장하기' : '수정하기'}
                    </Button>
                </div>

                <div className="row">
                    <div className="inner-row">
                        <p className="label-left">과세 구분</p>
                        <Dropdown
                            id={'texation'}
                            options={[
                                {key : '간이과세자', value : '간이과세자'},
                                {key : '일반과세자', value : '일반과세자'},
                            ]}
                            width={326}
                            value={taxation}
                            onItemClick={(val) => setTaxation(val)}
                            disabled={!isModify}
                        />
                    </div>

                    <div className="inner-row">
                        <p className="label-right">사업자 등록번호</p>
                        <Input
                            value={businessNum}
                            onChange={(e) => setBusinessNum(convertBuisnessNum(e.target.value))}
                            style={{ width : 326 }}
                            disabled={!isModify}
                            maxLength={12}
                        />
                    </div>
                </div>

                <div className="row">
                    <div className="inner-row">
                        <p className="label-left">업태</p>
                        <Input
                            value={businessCondition}
                            onChange={(e) => setBusinessCondition(e.target.value)}
                            style={{ width : 326 }}
                            disabled={!isModify}
                        />
                    </div>

                    <div className="inner-row">
                        <p className="label-right">업종</p>
                        <Input
                            value={businessSectors}
                            onChange={(e) => setBusinessSectors(e.target.value)}
                            style={{ width : 326 }}
                            disabled={!isModify}
                        />
                    </div>
                </div>

                <div className="row">
                    <div className="inner-row">
                        <p className="label-left">상호명</p>
                        <Input
                            value={storeName}
                            onChange={(e) => setStoreName(e.target.value)}
                            style={{ width : 326 }}
                            disabled={!isModify}
                        />
                    </div>

                    <div className="inner-row">
                        <p className="label-right">개업연월일</p>
                        <DatePicker
                            value={openDate}
                            style={{ width : 326 }}
                            disabled={!isModify}
                            onChange={(val) => setOpenDate(val)}
                        />
                    </div>
                </div>

                <div className="row">
                    <div className="inner-row">
                        <p className="label-left">대표자명</p>
                        <Input
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            style={{ width : 326 }}
                            disabled={!isModify}
                        />
                    </div>

                    <div className="inner-row">
                        <p className="label-right">생년월일</p>
                        <DatePicker
                            value={birth}
                            style={{ width : 326 }}
                            disabled={!isModify}
                            onChange={(val) => setBirth(val)}
                        />
                    </div>
                </div>

                <div className="row">
                    <div className="inner-row">
                        <p className="label-left">예금주명</p>
                        <Input
                            value={accountHolder}
                            onChange={(e) => setAccountHolder(e.target.value)}
                            style={{ width : 326 }}
                            disabled={!isModify}
                        />
                    </div>
                </div>

                <div className="row">
                    <div className="inner-row">
                        <p className="label-left">계좌번호</p>
                        <Dropdown
                            id={'bank-list'}
                            options={bankList}
                            width={144}
                            btnStyle={{ marginRight : 16 }}
                            value={ bank }
                            onItemClick={(val) => {setBank(val.Name);setBankCode(val.Code);}}
                            disabled={!isModify}
                        />
                        <Input
                            value={accountNum}
                            onChange={(e) => setAccountNum(e.target.value)}
                            style={{ width : 632 }}
                            disabled={!isModify}
                        />
                    </div>
                </div>

                <div className="row" style={{ marginBottom : 8 }}>
                    <div className="inner-row">
                        <p className="label-left">사업장<br/>소재지</p>
                        <Input
                            value={address}
                            onChange={(e) => setAddress(e.target.value)}
                            style={{ width : 695, marginRight : 8 }}
                            disabled
                        />
                        <Button variant='main' disabled={!isModify} style={{ width : 88, paddingTop : 12, paddingBottom : 12 }} onClick={() => modalRef.current.openModal()}>
                            검색
                        </Button>
                    </div>
                </div>

                <div className="row" style={{ marginBottom : 16 }}>
                    <div className="inner-row">
                        <p className="label-left"></p>
                        <Input
                            value={roadAddress}
                            onChange={(e) => setRoadAddress(e.target.value)}
                            style={{ width : 792 }}
                            disabled
                        />
                    </div>
                </div>

                <div className="row">
                    <div className="inner-row">
                        <p className="label-left">상세주소</p>
                        <Input
                            value={detailAddress}
                            onChange={(e) => setDetailAddress(e.target.value)}
                            style={{ width : 792 }}
                            disabled={!isModify}
                        />
                    </div>
                </div>
            </div>

            {/* 주소 검색 모달 */}
            <Modal ref={modalRef} contentContainer={{ width : 500 }} isHeader title="주소검색">
                <SetAddress handleAddress={handleAddress}/>
            </Modal>
        </div>
    )
}

export default JungsanInfo;